import React from 'react';
import {
	WhatsappShareButton,
	TelegramShareButton,
	VKShareButton,
	TwitterShareButton,
	RedditShareButton,
} from 'react-share';
import Icon from '@/components/atoms/UI/Icon/Icon';
import FlexContainer from '@/components/molecules/FlexContainer';
import styled from 'styled-components';
import { transition } from '@/styles/template';

interface Props {
	url: string
}

const StyledFlexContainer = styled(FlexContainer)`
  & > a {
    transition: ${transition.fastEnd};
  }
  
  & > button:hover {
    opacity: .7;
  }
`;

const ShareButtons: React.FC<Props> = ({ url }) => {
	const domain = window.location.hostname;
	const size: number = 4;

	const isEnglishDomain = domain.startsWith('en.');

	return (
		<StyledFlexContainer gap="2" centeredContentMobileOnly>
			{/* WhatsApp */}
			<WhatsappShareButton url={url}>
				<Icon name={'WhatsApp'} size={size} />
			</WhatsappShareButton>

			{/* Telegram */}
			<TelegramShareButton url={url}>
				<Icon name={'Telegram'} size={size} />
			</TelegramShareButton>

			{/* VK (если не английский домен) */}
			{!isEnglishDomain && (
				<VKShareButton url={url}>
					<Icon name={'VK'} size={size} />
				</VKShareButton>
			)}

			{/* Twitter/X */}
			<TwitterShareButton url={url}>
				<Icon name={'Twitter'} size={size} />
			</TwitterShareButton>

			{/* Reddit (если английский домен) */}
			{isEnglishDomain && (
				<RedditShareButton url={url}>
					<Icon name={'Reddit'} size={size} />
				</RedditShareButton>
			)}
		</StyledFlexContainer>

	);
};

export default ShareButtons;
